module.exports = __webpack_public_path__ + "common/icon-facebook-8909893f29f25c9de314311325ed4d41.svg";